import './token-status-badge.scss';

export type TokenStatusBadgeVariant = 'green' | 'yellow' | 'grey' | 'red';

interface ITokenStatusBadge {
  text: string;
  variant?: TokenStatusBadgeVariant;
  minWidth?: number;
}

export default function TokenStatusBadge({
  text,
  variant = 'grey',
  minWidth = 0,
}: ITokenStatusBadge) {
  return (
    <div
      style={{
        minWidth: `${minWidth}px`,
      }}
      className={`token-status-badge token-status-badge_variant_${variant}`}
    >
      {text}
    </div>
  );
}
